export function _setSpriteApi(sprite) {
  setProperties.bind(this)(sprite);

  sprite.setText = text => {
    sprite.children.find(child => child.isCSS2DObject).element.textContent = text;
  };

  sprite.setTextSize = size => {
    sprite.children.find(child => child.isCSS2DObject).element.style.fontSize = `${size}px`;
  };

  sprite.show = () => {
    sprite.traverse(object => (object.visible = true));
  };

  sprite.hide = () => {
    sprite.traverse(object => (object.visible = false));
  };

  sprite.onClick = callback => {
    if (sprite.onClickSprite === undefined) sprite.onClickSprite = [];
    sprite.onClickSprite.push(callback);
  };

  sprite.showAd = () => {
    sprite.hide();
    const size = sprite.userData.adInfo.size;
    const bool = true;
    const event = {type: "show", value: {size, bool}};
    this.context.adBannerEventDispatch(event);
  };

  sprite.hideAd = () => {
    sprite.hide();
    const size = sprite.userData.adInfo.size;
    const bool = false;
    const event = {type: "show", value: {size, bool}};
    this.context.adBannerEventDispatch(event);
  };

  sprite.onClickAdBanner = () => {
    const {click_api, click_tracking_api, landing_url} = sprite.userData.adInfo;
    fetch(click_api);
    fetch(click_tracking_api);
    window.open(landing_url, "_blank");
  };
}

function setProperties(sprite) {
  if (!sprite.userData?.guiTransform) return;
  const {center, anchor, offset, size, constantAspectRatio} = sprite.userData.guiTransform;
  const context = this.context;
  const handler = {
    set(obj, prop, value) {
      Reflect.set(...arguments);
      context.updateSpriteTransform(sprite);
      return true;
    },
  };

  const _anchor = {x: anchor.x, y: anchor.y};
  const anchorProxy = new Proxy(_anchor, handler);

  const _offsetX = {value: offset.x.value, unit: offset.x.unit};
  const _offsetY = {value: offset.y.value, unit: offset.y.unit};
  const offsetProxy = {};
  Object.defineProperties(offsetProxy, {
    x: {value: new Proxy(_offsetX, handler)},
    y: {value: new Proxy(_offsetY, handler)},
  });

  const _sizeX = {value: size.x.value, unit: size.x.unit};
  const _sizeY = {value: size.y.value, unit: size.y.unit};
  const sizeProxy = {};
  Object.defineProperties(sizeProxy, {
    x: {value: new Proxy(_sizeX, handler)},
    y: {value: new Proxy(_sizeY, handler)},
  });

  sprite.center.set(center.x, center.y);
  Object.defineProperties(sprite, {
    anchor: {value: anchorProxy, configurable: true},
    offset: {value: offsetProxy, configurable: true},
    size: {value: sizeProxy, configurable: true},
    _constantAspectRatio: {value: constantAspectRatio, configurable: true, writable: true},
    constantAspectRatio: {
      get() {
        return this._constantAspectRatio;
      },
      set(value) {
        this._constantAspectRatio = value;
        context.updateSpriteTransform(sprite);
      },
      configurable: true,
    },
  });
}

export function _removeSpriteApi(sprite) {
  // revert sprite's properties for edit mode
  sprite.center.copy(sprite.userData.guiTransform.center);
  sprite.children.find(child => child.isCSS2DObject).element.textContent = sprite.userData.css.textContent;
  sprite.traverse(object => (object.visible = true));

  delete sprite.anchor;
  delete sprite.offset;
  delete sprite.size;
  delete sprite._constantAspectRatio;
  delete sprite.constantAspectRatio;
  delete sprite.setText;
  delete sprite.setTextSize;
  delete sprite.show;
  delete sprite.hide;
  delete sprite.onClick;
  delete sprite.onClickSprite;
  delete sprite.showAd;
  delete sprite.hideAd;
  delete sprite.onClickAdBanner;
}
